"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var review_carousel_1 = require("../../utils/shopify-graphql/review-carousel");
var path_1 = require("../../utils/shopify/path");
var ReviewCarouselMain_1 = require("./ReviewCarouselMain");
var ReviewCarousel = function () {
    var _a = (0, hooks_1.useState)(null), reviews = _a[0], setReviews = _a[1];
    var _b = (0, hooks_1.useState)(''), color = _b[0], setColor = _b[1];
    var _c = (0, hooks_1.useState)(null), readMore = _c[0], setReadMore = _c[1];
    (0, hooks_1.useEffect)(function () {
        var handle = location.pathname.split('/')[2];
        // this will return 'collection', 'product', or 'page' based on url
        var pathType = (0, path_1.getPathType)(location);
        if (!pathType) {
            console.error('this module needs to be loaded within Collection or Page or Product url');
            return;
        }
        (0, review_carousel_1.getReviewCarouselData)(handle, pathType).then(function (data) {
            if (data) {
                var reviews_1 = data.reviews;
                if (data.testReviews && window.sessionStorage.getItem('reviews-ab') == 'true') {
                    reviews_1 = data.testReviews;
                }
                setReviews(reviews_1);
                setReadMore(data.readMoreLink || null);
                setColor(data.theme || 'default');
            }
        });
    }, []);
    //ensure reviews and color retrieved then show Swiper, otherwise it will be visually broken
    if (reviews) {
        return ((0, preact_1.h)("div", null,
            (0, preact_1.h)(ReviewCarouselMain_1.default, { reviews: reviews, color: color, readMore: readMore })));
    }
    else {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
};
exports.default = ReviewCarousel;
